import { useState } from "react";
import { Wrench, Menu, X, User } from "lucide-react";
import { toast } from "sonner";
import { COMPANY, NAV_LINKS } from "../mock";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const accountClick = (e) => {
    e.preventDefault();
    toast.info("Area riservata in arrivo", {
      description: "La sezione \"Il mio account\" sarà disponibile nella prossima fase del progetto.",
    });
  };

  return (
    <nav data-testid="sticky-navbar" className="sticky top-0 z-50 bg-[#191512]/95 backdrop-blur-md shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a href="#home" data-testid="navbar-logo" className="flex items-center gap-3 group">
            <span className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#c8102e] shadow-md shadow-[#c8102e]/40 transition-transform duration-300 group-hover:rotate-12">
              <Wrench className="w-5 h-5 sm:w-6 sm:h-6 text-white" strokeWidth={2.5} />
            </span>
            <span className="leading-tight">
              <span className="block font-condensed font-black uppercase text-white text-xl sm:text-2xl tracking-wide">
                Napolano <span className="text-[#c8102e]">Impianti</span>
              </span>
              <span className="block font-condensed font-bold uppercase text-[#4caf7d] text-xs sm:text-sm tracking-widest">
                {COMPANY.tagline}
              </span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={link.testid}
                className="text-white/85 hover:text-[#4caf7d] text-sm font-medium transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#account"
              onClick={accountClick}
              data-testid="nav-link-account"
              className="flex items-center gap-2 text-white/85 hover:text-[#4caf7d] text-sm font-medium transition-colors duration-200"
            >
              <User className="w-4 h-4" />
              Il mio account
            </a>
            <a
              href="#pacchetti"
              data-testid="nav-cta-button"
              className="bg-[#c8102e] hover:bg-[#a50d26] text-white font-semibold text-sm px-5 py-2.5 rounded-full shadow-md shadow-[#c8102e]/30 transition-all duration-200 hover:-translate-y-0.5"
            >
              Abbonati ora
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div data-testid="nav-mobile-menu" className="lg:hidden pb-4 space-y-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`${link.testid}-mobile`}
                className="block text-white/85 hover:text-[#4caf7d] py-2 text-sm font-medium"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#account"
              onClick={accountClick}
              data-testid="nav-link-account-mobile"
              className="flex items-center gap-2 text-white/85 py-2 text-sm font-medium"
            >
              <User className="w-4 h-4" />
              Il mio account
            </a>
            <a
              href="#pacchetti"
              onClick={() => setOpen(false)}
              data-testid="nav-cta-button-mobile"
              className="inline-block bg-[#c8102e] text-white font-semibold text-sm px-5 py-2.5 rounded-full mt-2"
            >
              Abbonati ora
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};
